import { number, object, string } from "yup";
import i18next from "/app/src/locales/config";

export const newOrderBuilderIntegrationSchema = object().shape({
  name: string().required(i18next.t("translation:required")),
  number: string().required(i18next.t("translation:required")),
  token: string().when("number", {
    is: (number) => number === "automatic",
    then: (schema) => schema.required(i18next.t("translation:required")),
  }),
  reportId: number().when("number", {
    is: (number) => number === "automatic",
    then: (schema) => schema.required(i18next.t("translation:required")),
  }),
});
